import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import { cn } from '@/lib/utils'
import { placed, placedChild } from '@/lib/style-guard'

function TooltipProvider({ children }: { children: React.ReactNode }) {
  return (
    <TooltipPrimitive.Provider delayDuration={300} skipDelayDuration={0}>
      {children}
    </TooltipPrimitive.Provider>
  )
}

function Tooltip({ children, ...props }: TooltipPrimitive.TooltipProps) {
  return <TooltipPrimitive.Root {...props}>{children}</TooltipPrimitive.Root>
}

function TooltipTrigger({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Trigger>) {
  return <TooltipPrimitive.Trigger className={placed(className, 'TooltipTrigger', props)} {...props} />
}

function TooltipContent({
  className,
  sideOffset = 8,
  ...props
}: React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>) {
  placedChild(props.asChild ? props.children : null, 'TooltipContent')
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        sideOffset={sideOffset}
        className={cn(
          'z-[var(--z-tooltip)] max-w-[240px] rounded-[var(--radius-md)] px-3 py-1.5',
          'bg-[var(--color-neutral-900)] text-[var(--color-neutral-0)]',
          'text-small leading-snug',
          'shadow-[var(--shadow-md)]',
          'animate-in fade-in-0 zoom-in-95',
          'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95',
          'dark:bg-[var(--surface-elevated)] dark:text-[var(--text-primary)] dark:border dark:border-[var(--border-default)]',
          placed(className, 'TooltipContent', props)
        )}
        {...props}
      />
    </TooltipPrimitive.Portal>
  )
}

export { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent }
